<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="100px"
      label-position="right">
      <el-form-item label="服务名称" prop="serviceName">
        <el-input v-model="formData.serviceName" placeholder="请输入服务名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属公园" prop="projectId">
        <el-select v-model="formData.projectId" ref="select" placeholder="请选择所属公园" clearable filterable
          @change="changePark">
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务类型" prop="typeId">
        <el-select v-model="formData.typeId" placeholder="请选择服务类型" clearable filterable>
          <el-option v-for="(item, index) in serviceList" :key="index" :label="item.typeName"
            :value="item.typeId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="fileList">
        <template slot="label">
          <span>服务封面图<br>(最多六张)</span>
        </template>
        <custom-upload v-model="formData.fileList"></custom-upload>
      </el-form-item>
      <el-form-item label="服务介绍" prop="description">
        <el-input type="textarea" placeholder="请输入服务介绍" v-model="formData.description" maxlength="1000" :rows="8"
          show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="服务位置" prop="resourcesLocationList">
        <div class="map">
          <el-button class="button" type="primary" @click="getInput">手动输入</el-button>
          <CustomMapMarker ref="map" :isClickPolyon="false" @input="getPosition"
            :value="formData.resourcesLocationList">
          </CustomMapMarker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
    <SetLatLngDialog :isShowInput.sync="isShowInput" :value="formPosition" @getlnglat='getlnglat'></SetLatLngDialog>
  </el-card>
</template>

<script>
import SetLatLngDialog from '@/components/SetLatLngDialog'
import { handleTLnglatList } from '@/utils/util'
export default {
  name: 'InparkserviceAdd',
  components: {
    SetLatLngDialog
  },
  data() {
    return {
      isShowInput: false,
      disabled: false,
      parkList: [],
      serviceList: [],
      mapRef: null,
      formData: {
        projectId: '',
        typeId: '',
        serviceName: '',
        description: '',
        fileList: [],
        resourcesLocationList: []
      },
      formPosition: {
        longitude: '',
        latitude: ''
      },
      rules: {
        serviceName: [
          { required: true, message: '请输入服务名称', trigger: ['blur', 'change'] }
        ],
        projectId: [
          { required: true, message: '请选择所属公园', trigger: ['blur', 'change'] }
        ],
        typeId: [
          { required: true, message: '请择服务类型', trigger: ['blur', 'change'] }
        ],
        fileList: [
          { required: true, message: '请选择服务封面图', trigger: ['blur', 'change'] }
        ],
        resourcesLocationList: [
          { required: true, message: '请选择服务位置', trigger: ['blur', 'change'] }
        ]
      },
      polygonOverlays: [], // 用于存储多边形覆盖物的数组
    }
  },
  computed: {
    id() {
      return this.$route.params.id || ''
    },
    projectId() {
      return this.$route.query.projectId || ''
    }
  },
  created() {
    this.getPark()
    this.getTypeList()
    if (this.id) {
      this.loadData()
    }
  },
  mounted() {
    this.mapRef = this.$refs.map
    this.projectId && this.drawPolyon(this.projectId)
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    changePark(val) {
      this.drawPolyon(val)
    },
    // 围栏
    drawPolyon(projectId) {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: projectId
      }).then(res => {
        console.log(res, '建管')
        const parkInfo = res || {}
        // 绘制公园中心点
        // this.center = [{ longitude: parkInfo.longitude, latitude: parkInfo.latitude }]
        // 绘制电子围栏
        this.mapRef.setZoomAndCenter(15, [+parkInfo.longitude, +parkInfo.latitude])
        this.fenceList = handleTLnglatList(res.locationList || [])
        // 重新绘制前清除所有
        // 重新绘制前清除所有多边形覆盖物
        this.polygonOverlays.forEach(overlay => {
          overlay.setMap(null);
        });
        this.polygonOverlays = []; // 清空数组

        // 绘制多边形
        this.mapRef.drawPolyons(this.fenceList)
      }).finally(() => {
        this.loading = false
      })
    },
    getTypeList() {
      this.$axios.get(this.$apis.tourist.selectServiceTypeByList).then(res => {
        this.serviceList = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    loadData() {
      this.$axios.get(this.$apis.tourist.selectServiceFacilitiesByServiceId, {
        serviceId: this.id
      }).then(res => {
        this.formData = res
      })
    },
    onInput(value) {
      this.formData.description = value
    },
    // 获取打点经纬度
    getPosition(val) {
      this.formData.resourcesLocationList = val
    },
    getInput() {
      this.isShowInput = true
      if (this.formData.resourcesLocationList[0]) {
        this.formPosition = JSON.parse(JSON.stringify(this.formData.resourcesLocationList[0]))
      }
    },
    getlnglat(val) {
      this.formData.resourcesLocationList = JSON.parse(JSON.stringify([{ ...val }]))
      const lngLat = [+this.formData.resourcesLocationList[0].longitude, +this.formData.resourcesLocationList[0].latitude]
      this.mapRef.setZoomAndCenter(lngLat)
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.disabled = true
        const url = this.id ? this.$apis.tourist.updateServiceFacilities : this.$apis.tourist.insertServiceFacilities
        this.$axios.post(url, this.formData).then(() => {
          this.$router.push('/inparkservice')
        }).finally(() => {
          this.disabled = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-textarea {
  width: 800px;
}

.map {
  position: relative;

  .button {
    position: absolute;
    top: 130px !important;
    left: 695px !important;
    z-index: 1000;
  }
}
</style>
